import { LOCATION_CITIES } from './locationCities';

export const WPENGINE_BASE_URL = '/api/wpengine'; // wpengine proxy for cache

// PATH are destinations, not routing regexes
export const SELL_MY_CAR_PATH = '/sell-my-car';
export const SELL_MY_VAN_PATH = '/sell-my-van';
export const SELL_YOUR_CAR_PATH = '/sell-your-car';

export const GUIDES_PATH = '/guides';
export const GUIDES_SELL_MY_CAR_PATH = '/sell-my-car/guides/how-to-sell-a-car';

export const CONTACT_PATH = 'https://help.motorway.co.uk/hc/en-gb';

export const WHY_MOTORWAY_PATH = '/why-motorway';
export const WHY_YOU_GET_MORE_PATH = '/why-you-get-more';

export const HOW_IT_WORKS_PATH = '/how-it-works';

export const SERVICE_FEES_PATH = '/service-fees';

export const STORIES_PATH = '/stories';

export const BLOG_PATH = '/blog';

export const PART_EXCHANGE_PATH = '/part-exchange';

export const CAR_PRIZE_DRAW_PATH = '/car-prize-draw';
export const CAR_PRIZE_DRAW_OPEN_SLUG = 'car-prize-draw-open';
export const CAR_PRIZE_DRAW_CLOSED_SLUG = 'car-prize-draw-closed';

const SELL_MY_CAR_PPC_ROUTES = Object.freeze([
  `${SELL_MY_CAR_PATH}/bluelightcard`,
  `${SELL_MY_CAR_PATH}/cardoffers`,
  `${SELL_MY_CAR_PATH}/gocompare`,
  `${SELL_MY_CAR_PATH}/newday`,
  `${SELL_MY_CAR_PATH}/partnerprizedraw`,
]);

export const NEW_LANDING_PAGE_ROUTES = Object.freeze([
  SELL_MY_CAR_PATH,
  WHY_MOTORWAY_PATH,
  WHY_YOU_GET_MORE_PATH,
]);

export const LANDING_PAGE_ROUTES = Object.freeze([
  `${SELL_MY_CAR_PATH}/:vehicle?-buyers`,
  `${SELL_MY_CAR_PATH}/moneysupermarket`,
  `${SELL_MY_CAR_PATH}/quidco`,
  `${SELL_MY_CAR_PATH}/topcashback`,
  `${SELL_MY_CAR_PATH}/giveasyoulive`,
  `${SELL_MY_CAR_PATH}/easyfundraising`,
  `${SELL_MY_CAR_PATH}/kidstart`,
  `${SELL_MY_CAR_PATH}/refer`,
  `${SELL_MY_CAR_PATH}/ulez`,
  ...SELL_MY_CAR_PPC_ROUTES,
]);

export const VALUATION_TRACKER_ROUTES = Object.freeze([
  '/car-value-tracker',
]);

export const MOT_PAGE_ROUTES = Object.freeze([
  '/mot-check',
  '/mot-check/results',
]);

export const MOT_VALUATION_ROUTE = MOT_PAGE_ROUTES[0];

export const TAX_PAGE_ROUTES = Object.freeze([
  '/car-tax-check',
  '/car-tax-check/results',
]);

export const TAX_VALUATION_ROUTE = TAX_PAGE_ROUTES[0];

const MILEAGE_SUFFIX_REGEX = /\/mileage\/?$/;

export const LOCATION_PAGE_ROUTES = Object.freeze(
  LOCATION_CITIES.map((city) => `${SELL_YOUR_CAR_PATH}/${city}`),
);

export const PAGE_BUILDER_PAGES = Object.freeze([
  { path: `${SELL_MY_CAR_PATH}/page-builder`, slug: 'page-builder', withMileageRoute: true },
  { path: HOW_IT_WORKS_PATH, slug: 'how-it-works' },
  { path: SERVICE_FEES_PATH, slug: 'service-fees' },
  { path: `${SELL_MY_CAR_PATH}/scrap-my-car`, slug: 'scrap-my-car-v2', withMileageRoute: true, withVideoSchema: true },
  { path: SELL_MY_VAN_PATH, slug: 'sell-my-van-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/on-finance`, slug: 'on-finance-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/car-buying-sites`, slug: 'car-buying-sites-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/car-buyers`, slug: 'car-buyers-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/petrol`, slug: 'petrol-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/diesel`, slug: 'diesel-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/to-a-dealer`, slug: 'to-a-dealer-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/electric`, slug: 'electric-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/bereavement`, slug: 'bereavement-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/hybrid`, slug: 'hybrid-v2', withMileageRoute: true, withVideoSchema: true },
  { path: `${SELL_MY_CAR_PATH}/cash-for-cars`, slug: 'cash-for-cars-v2', withMileageRoute: true, withVideoSchema: true },
  {
    path: CAR_PRIZE_DRAW_PATH,
    slug: (featureFlags) => (featureFlags?.showCarPrizeDraw ? CAR_PRIZE_DRAW_OPEN_SLUG : CAR_PRIZE_DRAW_CLOSED_SLUG),
    withMileageRoute: true,
  },
  ...LOCATION_PAGE_ROUTES.map((path) => ({
    path,
    slug: `${path.slice(1).replace('/', '-')}`,
    withMileageRoute: true,
  })),
]);

export const PAGE_BUILDER_PAGE_ROUTES = Object.freeze(PAGE_BUILDER_PAGES.map(({ path }) => path));

export const PAGE_BUILDER_NEW_DESIGN_ROUTES = Object.freeze(
  PAGE_BUILDER_PAGES.filter(({ withVideoSchema }) => withVideoSchema).map(({ path }) => path),
);

export const PAGE_BUILDER_ROUTES = Object.freeze(PAGE_BUILDER_PAGES.flatMap(({ path, withMileageRoute }) => (
  withMileageRoute ? [path, `${path}/mileage`] : [path]
)));

export const getPageBuilderSlug = (path = '', featureFlags = {}) => {
  const { slug } = PAGE_BUILDER_PAGES
    .find((page) => page.path === path.replace(MILEAGE_SUFFIX_REGEX, '')) ?? {};

  return typeof slug === 'function' ? slug(featureFlags) : slug;
};

export const NO_SITEMAP_ROUTES = Object.freeze([
  SELL_MY_CAR_PATH,
  `${SELL_MY_CAR_PATH}/moneysupermarket`,
  `${SELL_MY_CAR_PATH}/quidco`,
  `${SELL_MY_CAR_PATH}/topcashback`,
  `${SELL_MY_CAR_PATH}/giveasyoulive`,
  `${SELL_MY_CAR_PATH}/easyfundraising`,
  `${SELL_MY_CAR_PATH}/kidstart`,
  `${SELL_MY_CAR_PATH}/ulez`,
  `${SELL_MY_CAR_PATH}/refer`,
  `${SELL_MY_CAR_PATH}/cash-for-cars`,
  ...VALUATION_TRACKER_ROUTES,
  '/verify',
  ...PAGE_BUILDER_NEW_DESIGN_ROUTES.map((route) => `${route}-v2`),
  ...SELL_MY_CAR_PPC_ROUTES,
  SELL_YOUR_CAR_PATH,
  `${SELL_MY_CAR_PATH}/page-builder`,
  CAR_PRIZE_DRAW_PATH,
  `${CAR_PRIZE_DRAW_PATH}-open`,
  `${CAR_PRIZE_DRAW_PATH}-closed`,
]);

export const ULEZ_PAGE_ROUTES = Object.freeze([
  '/ulez-checker',
  '/ulez-checker/:results',
]);

export const WORDPRESS_ROUTES_CONFIG = Object.freeze([
  { path: `${SELL_MY_CAR_PATH}/guides/:subdir?/:author?`, section: 'guides', zendeskWidget: true },
  { path: '/guides/:subdir?/:author?', section: 'guides', zendeskWidget: true },
  { path: '/blog/:year?/:month?/:day?/:post?', section: 'blog', zendeskWidget: true },
  { path: '/stories/:subdir?', section: 'stories', zendeskWidget: true },
  { path: '/press', section: 'press', zendeskWidget: true },
  { path: '/why-motorway', section: 'whyMotorway', zendeskWidget: true },
  { path: '/cookies', section: 'cookies' },
  { path: '/privacy', section: 'privacy' },
  { path: '/terms', section: 'terms' },
  { path: '/claims', section: 'claims' },
]);

export const WORDPRESS_ROUTES = Object.freeze([
  ...WORDPRESS_ROUTES_CONFIG.map((config) => config.path),
]);

export const FULL_LANDING_PAGE_ROUTES = Object.freeze([
  ...LANDING_PAGE_ROUTES,
  ...ULEZ_PAGE_ROUTES,
  ...VALUATION_TRACKER_ROUTES,
  ...NEW_LANDING_PAGE_ROUTES,
  MOT_VALUATION_ROUTE,
  TAX_VALUATION_ROUTE,
  PART_EXCHANGE_PATH,
  ...PAGE_BUILDER_PAGES.filter(({ withMileageRoute }) => withMileageRoute).map(({ path }) => path),
]);
